import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import Http from '../../../Http';

class GuiasEmbarque extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: `embarque/productos/${this.props.idembarque}/filter`, 
        deleteUrl: `embarque/productos/${this.props.idembarque}/delete`, 
        deleteField: 'producto', 
        modUrl: '' 
      }, TableOp.Table('Productos del Embarque', [
        { label: 'Folio Guia', id: 'g_folio' },
        { label: 'Cliente', id: 'cliente_rsocial' },
        { label: 'Unidad', id: 'unidad' },
        { label: 'Producto', id: 'producto' },
        { label: 'Piezas', id: 'cantidad' },
        { label: 'Peso', id: 'peso' },
        { label: 'Material Peligroso', id: 'material_peligroso' },
        { label: 'Descripcion', id: 'descripcion' },
      ], [{ id: 'delete', icon: 'delete' }]))
    this.table(0, this.rpp, " ", this.orderBy);
  }

  dialogClose = async (op) => {
		this.setState({ dialog: { show: false } })
		if (op === 1) {
			let Res = await Http.post(`${this.config.deleteUrl}`, this.deleteRow);
			if (!Res.error) {
				this.table(this.page, this.rpp, " ", this.orderBy);
			}
		}
	}

  render() {

    return (
      <div>
        <this.TableRender/>
      </div>
    )
  }
}

export default withRouter(GuiasEmbarque)